var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1669 30C24.1669 29.696 24.2695 29.3933 24.4762 29.1467L31.1429 21.1467C31.6135 20.5813 32.4549 20.504 33.0202 20.976C33.5855 21.4467 33.6615 22.2867 33.1909 22.8533L27.2229 30.0147L32.9762 37.164C33.4375 37.7373 33.3469 38.5773 32.7735 39.0387C32.2002 39.5 31.3615 39.4093 30.8989 38.836L24.4615 30.836C24.2655 30.592 24.1669 30.296 24.1669 30Z",
    fill: "#2C3036"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_866",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 20,
    width: 10,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1669 30C24.1669 29.696 24.2695 29.3933 24.4762 29.1467L31.1429 21.1467C31.6135 20.5813 32.4549 20.504 33.0202 20.976C33.5855 21.4467 33.6615 22.2867 33.1909 22.8533L27.2229 30.0147L32.9762 37.164C33.4375 37.7373 33.3469 38.5773 32.7735 39.0387C32.2002 39.5 31.3615 39.4093 30.8989 38.836L24.4615 30.836C24.2655 30.592 24.1669 30.296 24.1669 30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_866)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 14,
    width: 32,
    height: 32,
    transform: "rotate(90 45.5 14)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNav);
export default __webpack_public_path__ + "static/media/left-nav.191de49871cf120d0651872b304444cb.svg";
export { ForwardRef as ReactComponent };